module.exports = __webpack_public_path__ + "img/icon-fara-ulei.9d8e3385.png";